import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './Home';
import Services from './Services';
import Blog from './Blog';
import Quote from './Quote';
import Contact from './Contact';
import NotFound from './NotFound';

import NavBar from './../components/NavBar';
import Footer from './../components/Footer';

class App extends React.Component{
    render(){
        return(
            <React.Fragment>
                <NavBar />
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/servicios" component={Services} />
                    <Route path="/blog" component={Blog} />
                    <Route path="/cotizaciones" component={Quote} />
                    <Route path="/contacto" component={Contact} />
                    <Route component={NotFound} />
                </Switch>
                <Footer />
            </React.Fragment>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App.js